import { consoleRoutes } from "@sagot/constants";
import { useTranslation } from "@sagot/i18n";
import { AppLink, Field, Input, Select, Textarea } from "@sagot/ui";
import { useFormContext } from "react-hook-form";
import { useWorkspaceContext } from "../../../session/workspace-context";
import { WIDGET_LIMITS, type WidgetForm } from "./widget-model";

const K = "deployKnowledge.widgetStudio.content";
const STARTER_SLOTS = Array.from({ length: WIDGET_LIMITS.maxStarters }, (_, i) => i);

export function ContentPanel() {
  const { t } = useTranslation();
  const { summary } = useWorkspaceContext();
  const { register, formState } = useFormContext<WidgetForm>();
  const errors = formState.errors.content;
  return (
    <div className="space-y-5">
      <Field label={t(`${K}.welcome`)}>
        <Textarea rows={3} maxLength={500} {...register("content.welcome_message")} />
      </Field>
      <fieldset>
        <div className="mb-1.5 flex items-center justify-between">
          <legend className="label mb-0">{t(`${K}.starters`)}</legend>
          <span className="text-[11px] text-fg-subtle">{t(`${K}.startersMax`, { count: WIDGET_LIMITS.maxStarters })}</span>
        </div>
        <div className="space-y-2">
          {STARTER_SLOTS.map((index) => (
            <Input
              key={index}
              maxLength={120}
              placeholder={t(`${K}.starterPlaceholder`, { n: index + 1 })}
              aria-label={t(`${K}.starterPlaceholder`, { n: index + 1 })}
              {...register(`content.starter_questions.${index}`)}
            />
          ))}
        </div>
        <p className="hint">
          {t(`${K}.starterTip`)}{" "}
          <AppLink href={consoleRoutes.analytics(summary.slug)} className="font-semibold text-primary-ink hover:underline">
            {t(`${K}.analytics`)}
          </AppLink>
          .
        </p>
      </fieldset>
      <Field label={t(`${K}.placeholder`)}>
        <Input maxLength={80} {...register("content.placeholder")} />
      </Field>
      <div>
        <Field label={t(`${K}.privacyNotice`)}>
          <Textarea rows={2} maxLength={500} {...register("content.privacy_notice")} />
        </Field>
        <Field className="mt-2" label={t(`${K}.privacyUrl`)} error={errors?.privacy_url ? t(`${K}.privacyUrlInvalid`) : undefined}>
          <Input className="font-mono text-xs" type="url" inputMode="url" placeholder="https://" {...register("content.privacy_url")} />
        </Field>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <Field
          label={t(`${K}.charLimit`)}
          error={errors?.char_limit ? t(`${K}.charLimitRange`, { min: WIDGET_LIMITS.charLimitMin, max: WIDGET_LIMITS.charLimitMax }) : undefined}
        >
          <Input
            type="number"
            min={WIDGET_LIMITS.charLimitMin}
            max={WIDGET_LIMITS.charLimitMax}
            step={50}
            {...register("content.char_limit", { valueAsNumber: true })}
          />
        </Field>
        <Field label={t(`${K}.attachments`)}>
          <Select {...register("content.attachments")}>
            <option value="off">{t(`${K}.attachmentsOff`)}</option>
            <option value="images">{t(`${K}.attachmentsImages`)}</option>
            <option value="images_pdf">{t(`${K}.attachmentsImagesPdf`)}</option>
          </Select>
        </Field>
      </div>
    </div>
  );
}
